var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.videoDialogVisible,
            "modal-append-to-body": false,
            "append-to-body": "",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.videoDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "video-dialog" }, [
            _c("video", {
              ref: "video",
              attrs: {
                src: _vm.videoUrl,
                controls: "controls",
                autoplay: "autoplay",
                width: "100%",
              },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }